module.exports = __webpack_public_path__ + "static/media/visitor-posts.0ed1b80a.png";